import { StandardContent } from 'shared/types/models';

export function normalizeContent(content: StandardContent): string {
  return typeof content === 'string' ? content.trim().toLowerCase() : '';
}
